import {
    Alert,
    Box,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    IconButton,
    Menu,
    MenuItem,
    Snackbar,
    Tooltip,
    Typography
} from "@mui/material";
import {InsertChartOutlined, MoreVert, PieChartOutline, Telegram, Visibility} from "@mui/icons-material";
import React, {useState} from "react";
import {format} from "date-fns";
import {Link} from "react-router-dom";
import './survey-card.css';
import SlackDateTimePicker from "../schedule-slack/SlackDateTimePicker";
import DisplaySchedule from "../schedule-slack/DisplaySchedule";
import {useTranslation} from "react-i18next";
import {numberOfQuestions} from "../../../helpers/survey.helper";

const createOptions = (name, routerLink, translation) => {
    return {
        name,
        routerLink,
        translation
    }
}

const SurveySlackCardItem = (props) => {
    const {t} = useTranslation();

    const options = [
        /*createOptions('Send a copy', ''),
        createOptions('Transfer', ''),
        createOptions('Make a copy', ''),
        createOptions('Create template', ''),
        createOptions('Clear response', ''),*/
        createOptions('Delete', '', t('surveys.delete')),
    ]

    const {item, sending, sendSurveyToTeam} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [status, setStatus] = useState(item.active);
    const [open, setOpen] = useState(false);
    const [openShare, setOpenShare] = useState(null);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleCloseMenu = (option = '') => {
        setAnchorEl(null);
    }

    const handleOpenShareMenu = (event) => {
        setOpenShare(event.currentTarget);
    }

    const handleCloseShareMenu = () => {
        setOpenShare(null);
    }

    const getActiveSchedule = (schedules) => {

        if (schedules.length > 0) {
            for (let schedule of schedules) {
                if (schedule.state === true) {
                    return schedule;
                }
            }
        }
        return false;
    }

    const checkChartRoute = () => {
        if (item.templateId === null || item.templateId === 1) {
            return `/charts/${item.id}/questions-data`
        }
        return `/charts/${item.id}`;
    }

    return (
        <div className="h-100">
            <Card className="h-100 position-relative" style={{ position: 'relative' }}>
                <CardHeader
                    action={
                        <div>
                            <IconButton onClick={handleOpenMenu}><MoreVert/></IconButton>
                            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
                                {options.map((option, index) =>
                                    <MenuItem key={index}
                                              onClick={() => handleCloseMenu(option.name)}>{option.translation}</MenuItem>)}
                            </Menu>
                        </div>
                    }
                    title={item.title}
                    subheader={item.description}
                    sx={{
                        '& .MuiCardHeader-title': {
                            color: '#1A237E',
                            fontWeight: 600,
                            fontSize: '1.25rem',
                            fontFamily: 'Montserrat, sans-serif'
                        },
                        '& .MuiCardHeader-subheader': {
                            color: '#666',
                            fontSize: '0.9rem',
                            fontFamily: 'Montserrat, sans-serif'
                        }
                    }}
                />
                <CardContent sx={{ padding: '24px !important' }}>
                    <Typography gutterBottom component="div" sx={{ color: '#666', fontSize: '0.875rem' }}>
                        {t('surveys.created')}: <b style={{ color: '#1A237E' }}>{format(new Date(item.createdAt), 'MM/dd/yyyy')}</b>
                    </Typography>
                    <Typography gutterBottom component="div" sx={{ color: '#666', fontSize: '0.875rem' }}>
                        {t('surveys.modified')}: <b style={{ color: '#1A237E' }}>{format(new Date(item.updatedAt), 'MM/dd/yyyy')}</b>
                    </Typography>
                    {/*<Typography gutterBottom variant="body2" color="text.info">
                        Questions: <b>{numberOfQuestions(item)}</b>
                    </Typography>*/}

                    <Typography gutterBottom variant="body2" sx={{ color: '#666', fontSize: '0.875rem' }}>
                        {t('surveys.responses')}: <b style={{ color: '#1A237E' }}>{item.numberOfResponses || 0}</b>
                    </Typography>
                    {getActiveSchedule(item["slack_schedules"]) ?
                        <DisplaySchedule schedule={getActiveSchedule(item["slack_schedules"])}/> : null}

                    {sending[item.id] && (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                bgcolor: 'rgba(250,251,252,0.7)',
                                zIndex: 10,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backdropFilter: 'blur(2px)',
                                borderRadius: '12px',
                            }}
                        >
                            <CircularProgress color="primary" size={32} thickness={4} />
                            <Typography mt={2} fontWeight={500} color="#1A237E" fontSize={16}>
                                {t('sending')}...
                            </Typography>
                        </Box>
                    )}


                </CardContent>
            </Card>
            <div className="card-action-bottom border-top">
                <div className="d-flex justify-content-evenly animateHover">
                    <Tooltip title={t('survey.show')}>
                        <Link to={`/surveys-show/${item.id}`} params={{json: item.json}}>
                            <IconButton><Visibility/></IconButton>
                        </Link>
                    </Tooltip>
                    <Tooltip title={t('survey.sendTeam')}>
                        <IconButton disabled={sending[item.id]}
                                    onClick={() => sendSurveyToTeam(item.id, item.title, item.teamId)}><Telegram/></IconButton>
                    </Tooltip>


                    <Link to={checkChartRoute()}>
                        <Tooltip title={t('item.results')}>
                            <IconButton><PieChartOutline/></IconButton>
                        </Tooltip>
                    </Link>

                    {/*<Link to={`/charts/${item.id}/questions-data`}>
                        <Tooltip title={t('item.results')}>
                            <IconButton><InsertChartOutlined/></IconButton>
                        </Tooltip>
                    </Link>*/}

                    {getActiveSchedule(item["slack_schedules"]) === false ?
                        <SlackDateTimePicker surveyId={item.id}/> :
                        <div>
                            <SlackDateTimePicker surveyId={item.id}
                                                 days={getActiveSchedule(item["slack_schedules"]).days}
                                                 hours={getActiveSchedule(item["slack_schedules"]).hours}
                                                 minutes={getActiveSchedule(item["slack_schedules"]).minutes}
                                                 scheduleId={getActiveSchedule(item["slack_schedules"]).id}/>
                        </div>
                    }
                </div>
            </div>
            <div>
                <Snackbar open={open} autoHideDuration={3000} anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                          onClose={() => setOpen(false)}>
                    {status ?
                        <Alert severity="success" sx={{width: '100%'}} onClose={() => setOpen(false)}>
                            {t('item.play')}
                        </Alert> :
                        <Alert severity="warning" sx={{width: '100%'}} onClose={() => setOpen(false)}>
                            {t('item.pause')}
                        </Alert>
                    }

                </Snackbar>
            </div>
        </div>
    )
}

export default SurveySlackCardItem;
